import React, { Fragment } from "react";
import { AboutPageContainer, AboutText, AboutInfoContainer, AboutImage } from "./about-page-style";
import { useAboutUs } from "../../hooks";
import { Subtitle } from "../info-box/info-box-styles";

export const About = () => {
  const { title, content, image } = useAboutUs();

  return (
    <Fragment>
      <AboutPageContainer>
        <AboutInfoContainer>
          <Subtitle>{title}</Subtitle>
          {content.map(({ body }) => {
            return <AboutText>{body}</AboutText>;
          })}
        </AboutInfoContainer>
        <AboutImage src={image} />
      </AboutPageContainer>
    </Fragment>
  );
};
